import { Cpu, Wrench, Truck } from "lucide-react";

const icons = [Cpu, Wrench, Truck];

export function TechnicalCommercialCapabilities({ capabilities, cameraExpertise, images = [] }) {
  return (
    <>
      <section id="capabilities" className="section compact-capabilities-section capabilities-intro-section" data-testid="compact-capabilities-section">
        <div className="slide-split">
          <div className="section-heading wide">
            <p className="overline" data-testid="compact-capabilities-overline">{capabilities.overline}</p>
            <h2 data-testid="compact-capabilities-title">{capabilities.title}</h2>
            <p data-testid="compact-capabilities-description">{cameraExpertise.description}</p>
          </div>
          <div className="deck-image-panel capability-visual-panel" data-testid="capabilities-image-panel-1">
            {images[0]?.image ? <img src={images[0].image} alt={capabilities.title} data-testid="capabilities-image-1" /> : (
              <div className="technical-panel-content" data-testid="capabilities-visual-content-1">
                <span>{cameraExpertise.activity?.number || capabilities.overline}</span>
                <strong>{cameraExpertise.iq?.title}</strong>
                <p>{cameraExpertise.activity?.title}</p>
              </div>
            )}
          </div>
        </div>

        <div className="capability-signal-row" data-testid="capability-signal-row">
          <article className="expertise-card stat-card compact-stat capability-signal-card" data-testid="compact-camera-activity-card">
            <span data-testid="compact-camera-activity-number">{cameraExpertise.activity.number}</span>
            <h3 data-testid="compact-camera-activity-title">{cameraExpertise.activity.title}</h3>
            <p data-testid="compact-camera-activity-text">{cameraExpertise.iq.text}</p>
          </article>
          <article className="capability-signal-card thesis-strip" data-testid="compact-capability-thesis-card">
            <span data-testid="compact-capability-thesis-label">{capabilities.overline}</span>
            <strong data-testid="compact-capability-thesis-text">{capabilities.thesis}</strong>
          </article>
        </div>
      </section>

      <section className="section compact-capabilities-section capabilities-detail-section" data-testid="capabilities-detail-section">
        <div className="section-heading wide compact-heading">
          <p className="overline" data-testid="capabilities-detail-overline">{capabilities.overline}</p>
          <h2 data-testid="capabilities-detail-title">{capabilities.thesis}</h2>
        </div>

        {images[1]?.image ? (
          <div className="deck-strip-image" data-testid="capabilities-image-panel-2">
            <img src={images[1].image} alt={capabilities.overline} data-testid="capabilities-image-2" />
          </div>
        ) : null}

        <div className="compact-capability-grid" data-testid="compact-capability-grid">
          {capabilities.columns.map((column, index) => {
            const Icon = icons[index] || Cpu;
            return (
              <article className="matrix-column compact" key={column.title} data-testid={`compact-capability-column-${index + 1}`}>
                <div className="solution-icon" data-testid={`compact-capability-icon-${index + 1}`}>
                  <Icon size={22} aria-hidden="true" />
                </div>
                <span className="matrix-number" data-testid={`compact-capability-number-${index + 1}`}>{String(index + 1).padStart(2, "0")}</span>
                <h3 data-testid={`compact-capability-title-${index + 1}`}>{column.title}</h3>
                <ul data-testid={`compact-capability-list-${index + 1}`}>
                  {column.items.slice(0, 5).map((item) => (
                    <li key={item} data-testid={`compact-capability-item-${index + 1}-${item.toLowerCase().replaceAll(" ", "-").replaceAll("/", "")}`}>{item}</li>
                  ))}
                </ul>
              </article>
            );
          })}
        </div>
      </section>
    </>
  );
}